export default {
  charts: {},
  range: [],
};
